// extracted by mini-css-extract-plugin
export var acitonButtons = "_cy-0";
export var additionalIcon = "_cy-f";
export var block = "_cy-1";
export var blockContent = "_cy-7";
export var blockDescription = "_cy-8";
export var blockIcon = "_cy-9";
export var blockTitle = "_cy-6";
export var border = "_cy-a";
export var center = "_cy-l";
export var edge = "_cy-b";
export var edgeLabel = "_cy-c";
export var edgePath = "_cy-d";
export var error = "_cy-e";
export var flowchart = "_cy-g";
export var flowchartContent = "_cy-h";
export var highlighted = "_cy-3";
export var hover = "_cy-4";
export var icon = "_cy-i";
export var left = "_cy-m";
export var navButton = "_cy-j";
export var navButtons = "_cy-k";
export var right = "_cy-n";
export var selected = "_cy-2";
export var small = "_cy-5";